module.exports = __webpack_public_path__ + "img/pica-icon.3d423b08.svg";